import React, { Component } from 'react';
import { apiGet } from '../../Api';
import AdminAPI from './AdminAPI';
import { ImageLoader } from '../Game/ImageLoader';
import { MEDIA_VARIANTS } from '../../media';

const DEFAULT_FLEE_SETTINGS = {
    deltaFlat: 0,
    pMultiplier: 1,
    adrenalineBonus: 0,
    tickSeconds: 0.25,
    overrideS: null,
    overridePMin: null,
    overridePMax: null,
    overridePMaxFinal: null,
};

export default class RegionsDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageFile: null,
            imagePreviewUrl: '',
            animatedImageFile: null,
            animatedImagePreviewUrl: '',
            regions: null,
            selectedItem: null,
            loadedImages: {},
            loadedItems: {},
            requestedItem: false,
        };
    }


    componentDidUpdate = async (prevProps, prevState) => {
        console.log("update");
        if (this.props.regionId !== prevProps.regionId || this.props.creatingNewRegions !== prevProps.creatingNewRegions) {
            this.setState({ imageFile: null, imagePreviewUrl: null, animatedImagePreviewUrl: null, animatedImageFile: null });
            this.getRegions();

        }

        if (this.props.selectedItem && this.props.selectedItem !== this.state.selectedItem) {
            if (this.state.requestedItem) {
                console.log("update keyid");
                const regions = { ...this.state.regions, keyId: this.props.selectedItem.id };
                this.setState({ regions });
            }
            this.setState({ selectedItem: this.props.selectedItem, requestedItem: false });
        }
    }


    getRegions = async () => {
        if (this.props.regionId != null) {
            if (this.props.regionId === "") {
                // this.setState({ regions: null });
                this.setState({ regions: { name: "", visualDescription: "", flavourText: "", level: 1, roamingEnemyCount: null, enemyLevelDistribution: [], sequence: 0, keyId: "", xpRequired: 0, campRouteCostItemId: "", campRouteCostQuantity: 0, fleeSettings: { ...DEFAULT_FLEE_SETTINGS } }, imageFile: null, imagePreviewUrl: "" });
            }
            else {
                const response = await apiGet("/region/" + this.props.regionId);
                if (response.ok) {
                    const curr = await response.json();
                    curr.enemyLevelDistribution = Array.isArray(curr.enemyLevelDistribution)
                        ? curr.enemyLevelDistribution
                        : [];
                    const { hideAdjust: _deprecatedHideAdjust, ...persistedFlee } = curr.fleeSettings || {};
                    curr.fleeSettings = { ...DEFAULT_FLEE_SETTINGS, ...persistedFlee };
                    this.setState({ regions: curr });
                    if (curr.imageId) {
                        this.setState({ imagePreviewUrl: await AdminAPI.fetchImage(curr.imageId, MEDIA_VARIANTS.REGION) });
                        // this.fetchImage(curr.imageId);
                    }
                }
            }
        }
        else {
            this.setState({ regions: null });
        }
    }





    handleInputChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        }
        const regions = { ...this.state.regions, [name]: value };
        this.setState({ regions });
    };

    handleRouteCostItemChange = (event) => {
        const campRouteCostItemId = event.target.value;
        this.setState(prev => ({
            regions: {
                ...prev.regions,
                campRouteCostItemId,
                campRouteCostQuantity: campRouteCostItemId
                    ? Math.max(1, Number(prev.regions.campRouteCostQuantity) || 1)
                    : 0,
            },
        }));
    };

    handleRouteCostQuantityChange = (event) => {
        const campRouteCostQuantity = Math.max(
            0,
            Math.floor(Number(event.target.value) || 0),
        );
        this.setState(prev => ({
            regions: { ...prev.regions, campRouteCostQuantity },
        }));
    };

    handleRoamingEnemyCountChange = (event) => {
        const roamingEnemyCount = event.target.value === ''
            ? null
            : Math.max(0, Math.min(50, Math.floor(Number(event.target.value) || 0)));
        this.setState(prev => ({
            regions: { ...prev.regions, roamingEnemyCount },
        }));
    };

    handleEnemyLevelChanceChange = (index, field, rawValue) => {
        const value = Number(rawValue);
        this.setState(prev => ({
            regions: {
                ...prev.regions,
                enemyLevelDistribution: (prev.regions.enemyLevelDistribution || [])
                    .map((entry, entryIndex) => entryIndex === index
                        ? {
                            ...entry,
                            [field]: field === 'level'
                                ? Math.max(1, Math.floor(value) || 1)
                                : Math.max(0, Math.min(100, value || 0)),
                        }
                        : entry),
            },
        }));
    };

    addEnemyLevelChance = () => {
        this.setState(prev => {
            const entries = prev.regions.enemyLevelDistribution || [];
            const highestLevel = entries.reduce(
                (maximum, entry) => Math.max(maximum, Number(entry.level) || 0),
                Number(prev.regions.level) || 1,
            );
            return {
                regions: {
                    ...prev.regions,
                    enemyLevelDistribution: [
                        ...entries,
                        { level: highestLevel + (entries.length ? 1 : 0), chancePercent: entries.length ? 0 : 100 },
                    ],
                },
            };
        });
    };

    removeEnemyLevelChance = (index) => {
        this.setState(prev => ({
            regions: {
                ...prev.regions,
                enemyLevelDistribution: (prev.regions.enemyLevelDistribution || [])
                    .filter((_, entryIndex) => entryIndex !== index),
            },
        }));
    };

    normalizeFleeValue = (name, value) => {
        if (value === null || typeof value === 'undefined' || Number.isNaN(value)) {
            return null;
        }
        switch (name) {
            case 'deltaFlat':
                return Math.max(-30, Math.min(30, Math.round(value)));
            case 'pMultiplier':
                return Number(Math.min(1.3, Math.max(0.7, value)).toFixed(3));
            case 'adrenalineBonus':
                return Number(Math.min(0.05, Math.max(0, value)).toFixed(4));
            case 'tickSeconds':
                return Number(Math.min(0.5, Math.max(0.1, value)).toFixed(2));
            case 'overrideS':
                return value <= 0 ? null : Math.round(value);
            case 'overridePMin':
            case 'overridePMax':
            case 'overridePMaxFinal':
                return Number(Math.min(0.99, Math.max(0, value)).toFixed(3));
            default:
                return value;
        }
    };

    handleFleeSettingChange = (event) => {
        const { name, value } = event.target;
        let parsed = value;
        if (value === '' || value === null) {
            parsed = null;
        } else {
            const numeric = parseFloat(value);
            parsed = Number.isNaN(numeric) ? null : numeric;
        }

        this.setState(prev => {
            const current = prev.regions || {};
            const { hideAdjust: _deprecatedHideAdjust, ...merged } = { ...DEFAULT_FLEE_SETTINGS, ...(current.fleeSettings || {}) };
            const nextValue = this.normalizeFleeValue(name, parsed);
            return {
                regions: {
                    ...current,
                    fleeSettings: {
                        ...merged,
                        [name]: nextValue
                    }
                }
            };
        });
    };

    resetFleeSettings = () => {
        this.setState(prev => ({
            regions: {
                ...prev.regions,
                fleeSettings: { ...DEFAULT_FLEE_SETTINGS }
            }
        }));
    };


    removeKeyItem = (event) => {
        const regions = { ...this.state.regions, keyId: "" };
        this.setState({ regions });
    }














    showItemPopup = () => {
        this.setState({ requestedItem: true });
        this.props.showItemPopup();
    }


    //image
    handleImageChange = (e) => {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = async () => {
            this.setState({
                imageFile: file,
                imagePreviewUrl: reader.result
            });
            const assetId = await AdminAPI.handleMediaUpload(file, 'progresslands.region.v1');
            if (assetId) {
                const regions = { ...this.state.regions, imageId: assetId };
                this.setState({ regions });
            }

        };

        reader.readAsDataURL(file);


    };

    handleAnimatedMediaChange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const assetId = await AdminAPI.handleMediaUpload(file, 'progresslands.regionVideo.v1');
        if (assetId) {
            this.setState((prev) => ({
                regions: { ...prev.regions, animatedMediaId: assetId },
            }));
        }
    };











    //image end

    render() {
        const { onUpdate, onDelete, onCreate, creatingNewRegions, onCancelCreate, routeCostItems = [], routeCostItemsLoading = false, routeCostItemsError = '', saveError = '' } = this.props;
        const { regions, loadedImages, loadedItems, imagePreviewUrl, animatedImagePreviewUrl } = this.state;

        if (!regions || regions == null) return <div>Select a regions to see details</div>;

        const rawFlee = regions.fleeSettings ? { ...DEFAULT_FLEE_SETTINGS, ...regions.fleeSettings } : { ...DEFAULT_FLEE_SETTINGS };
        const { hideAdjust: _deprecatedHideAdjust, ...flee } = rawFlee;
        const routeCostItemId = regions.campRouteCostItemId || '';
        const routeCostQuantity = Number(regions.campRouteCostQuantity) || 0;
        const enemyLevelDistribution = Array.isArray(regions.enemyLevelDistribution)
            ? regions.enemyLevelDistribution
            : [];
        const enemyLevelTotal = enemyLevelDistribution.reduce(
            (total, entry) => total + (Number(entry.chancePercent) || 0),
            0,
        );
        const enemyLevels = enemyLevelDistribution.map(entry => Number(entry.level));
        const enemyLevelValidation = enemyLevelDistribution.some(entry => (
            !Number.isInteger(Number(entry.level))
            || Number(entry.level) < 1
            || !Number.isFinite(Number(entry.chancePercent))
            || Number(entry.chancePercent) <= 0
            || Number(entry.chancePercent) > 100
        ))
            ? 'Enemy level rows require a positive level and percentage.'
            : enemyLevelDistribution.length > 0
                && Math.abs(enemyLevelTotal - 100) > 0.01
            ? 'Enemy level percentages must total 100%.'
            : new Set(enemyLevels).size !== enemyLevels.length
                ? 'Enemy level rows must use unique levels.'
                : '';
        const selectedCostItemExists = routeCostItems.some(item => (
            String(item.id ?? item.Id) === routeCostItemId
        ));
        const routeCostValidation = regions.canBeStartRegion && routeCostItemId
            ? 'Start-region Camp routes are always free.'
            : routeCostItemId && routeCostQuantity <= 0
                ? 'Enter a positive cableway cost quantity.'
                : !routeCostItemId && routeCostQuantity > 0
                    ? 'Choose a stackable cableway cost item.'
                    : routeCostItemId
                        && !routeCostItemsLoading
                        && !routeCostItemsError
                        && !selectedCostItemExists
                        ? 'The selected cableway cost item is not stackable or no longer exists.'
                        : '';

        return (
            <div className='admin_details'>
                <label>Name:
                    <input type="text" name="name" value={regions.name} onChange={this.handleInputChange} />
                </label>
                <label>FlavourText:
                    <textarea type="text" name="flavourText" value={regions.flavourText} onChange={this.handleInputChange} />
                </label>
                <label>Visual Description:
                    <textarea type="text" name="visualDescription" value={regions.visualDescription} onChange={this.handleInputChange} />
                </label>
                <label>Image:
                    <input type="file" onChange={this.handleImageChange} />
                    {imagePreviewUrl && <img src={imagePreviewUrl} alt="Preview" className='adminPreviewImage' />}
                </label>
                <label>Animated media:
                    <input type="file" accept="video/*" onChange={this.handleAnimatedMediaChange} />
                </label>
                {(regions.animatedMediaId || regions.animatedImageId) && (
                    <ImageLoader
                        className="adminPreviewImage"
                        imageId={regions.imageId}
                        animatedMediaId={regions.animatedMediaId || regions.animatedImageId}
                        variant={MEDIA_VARIANTS.REGION}
                        posterVariant={MEDIA_VARIANTS.REGION_POSTER}
                        aspectRatio="16 / 9"
                        alt="Region media preview"
                    />
                )}

                <label>Level:
                    <input type="number" name="level" value={regions.level} onChange={this.handleInputChange} />
                </label>
                <fieldset>
                    <legend>Roaming enemy levels</legend>
                    <p className="admin-field-help">
                        Population controls ordinary roaming actors. Each spawn rolls one configured level; enemy level overrides still win.
                    </p>
                    <label>Ordinary roaming population:
                        <input
                            aria-label="Ordinary roaming population"
                            max="50"
                            min="0"
                            onChange={this.handleRoamingEnemyCountChange}
                            placeholder="Use roster count"
                            type="number"
                            value={regions.roamingEnemyCount ?? ''}
                        />
                    </label>
                    {enemyLevelDistribution.map((entry, index) => (
                        <div className="admin-inline-fields" key={`enemy-level-${index}`}>
                            <label>Enemy level {index + 1}:
                                <input
                                    aria-label={`Enemy level ${index + 1}`}
                                    min="1"
                                    onChange={(event) => this.handleEnemyLevelChanceChange(index, 'level', event.target.value)}
                                    step="1"
                                    type="number"
                                    value={entry.level}
                                />
                            </label>
                            <label>Chance percent {index + 1}:
                                <input
                                    aria-label={`Chance percent ${index + 1}`}
                                    max="100"
                                    min="0.01"
                                    onChange={(event) => this.handleEnemyLevelChanceChange(index, 'chancePercent', event.target.value)}
                                    step="0.01"
                                    type="number"
                                    value={entry.chancePercent}
                                />
                            </label>
                            <button
                                aria-label={`Remove enemy level ${index + 1}`}
                                className="button-secondary"
                                onClick={() => this.removeEnemyLevelChance(index)}
                                type="button"
                            >Remove</button>
                        </div>
                    ))}
                    <button className="button-secondary" onClick={this.addEnemyLevelChance} type="button">
                        Add enemy level
                    </button>
                    {enemyLevelDistribution.length === 0 ? (
                        <p className="admin-field-help">No rows: all ordinary enemies use the region level.</p>
                    ) : (
                        <p className="admin-field-help">Configured total: {enemyLevelTotal}%</p>
                    )}
                    {enemyLevelValidation && <p role="alert">{enemyLevelValidation}</p>}
                </fieldset>
                <p className="admin-field-help">
                    Map dimensions and the spawn point are managed in the World Editor.
                </p>
                <fieldset>
                    <legend>Camp cableway</legend>
                    <p className="admin-field-help" id="camp-route-cost-help">
                        Set this region's installation price here. The World Editor only places the Camp entrance anchor.
                    </p>
                    <label htmlFor="camp-route-cost-item">Cost item:
                        <select
                            aria-describedby="camp-route-cost-help"
                            disabled={routeCostItemsLoading}
                            id="camp-route-cost-item"
                            name="campRouteCostItemId"
                            onChange={this.handleRouteCostItemChange}
                            value={routeCostItemId}
                        >
                            <option value="">No installation cost</option>
                            {routeCostItemId && !selectedCostItemExists && (
                                <option value={routeCostItemId}>{routeCostItemId} (unavailable)</option>
                            )}
                            {routeCostItems.map(item => {
                                const itemId = String(item.id ?? item.Id);
                                return (
                                    <option key={itemId} value={itemId}>
                                        {item.name ?? item.Name ?? itemId}
                                    </option>
                                );
                            })}
                        </select>
                    </label>
                    <label htmlFor="camp-route-cost-quantity">Quantity:
                        <input
                            aria-describedby="camp-route-cost-help"
                            disabled={!routeCostItemId}
                            id="camp-route-cost-quantity"
                            min="1"
                            name="campRouteCostQuantity"
                            onChange={this.handleRouteCostQuantityChange}
                            type="number"
                            value={routeCostQuantity || ''}
                        />
                    </label>
                    {routeCostItemsLoading && <p role="status">Loading stackable items…</p>}
                    {routeCostItemsError && <p role="alert">{routeCostItemsError}</p>}
                    {routeCostValidation && <p role="alert">{routeCostValidation}</p>}
                    {saveError && <p role="alert">{saveError}</p>}
                </fieldset>
                <label>HP Regen Flat (per minute):
                    <input type="number" step="0.1" name="hpRegenFlatPerMinute" value={regions.hpRegenFlatPerMinute || 0} onChange={this.handleInputChange} />
                </label>
                <label>HP Regen Percent (%):
                    <input type="number" step="0.1" name="hpRegenPercent" value={regions.hpRegenPercent || 0} onChange={this.handleInputChange} />
                </label>
                <fieldset className='region-flee'>
                    <legend>Flee &amp; Chase Balancing</legend>
                    <p className="admin-field-help">
                        Tune how quickly players escape: <strong>Delta Flat</strong> adds or subtracts a flat percent from flee rolls,
                        <strong>pMultiplier</strong> scales the flee probability curve, <strong>Adrenaline Bonus</strong> grants extra adrenaline per tick,
                        and <strong>Tick Seconds</strong> sets the cadence. Override values let you hard-set advanced curve parameters
                        (S, pMin, pMax, pMaxFinal) instead of using defaults.
                    </p>
                    <label>Delta Flat:
                        <input type="number" name="deltaFlat" min="-30" max="30" step="1" value={flee.deltaFlat} onChange={this.handleFleeSettingChange} />
                    </label>
                    <label>pMultiplier:
                        <input type="number" name="pMultiplier" min="0.7" max="1.3" step="0.01" value={flee.pMultiplier} onChange={this.handleFleeSettingChange} />
                    </label>
                    <label>Adrenaline Bonus per Tick:
                        <input type="number" name="adrenalineBonus" min="0" max="0.05" step="0.001" value={flee.adrenalineBonus} onChange={this.handleFleeSettingChange} />
                    </label>
                    <label>Tick Seconds:
                        <input type="number" name="tickSeconds" min="0.1" max="0.5" step="0.01" value={flee.tickSeconds} onChange={this.handleFleeSettingChange} />
                    </label>
                    <label>Override S:
                        <input type="number" name="overrideS" step="1" value={flee.overrideS ?? ''} onChange={this.handleFleeSettingChange} placeholder="Default" />
                    </label>
                    <label>Override pMin:
                        <input type="number" name="overridePMin" min="0" max="0.5" step="0.001" value={flee.overridePMin ?? ''} onChange={this.handleFleeSettingChange} placeholder="Default" />
                    </label>
                    <label>Override pMax:
                        <input type="number" name="overridePMax" min="0" max="0.95" step="0.001" value={flee.overridePMax ?? ''} onChange={this.handleFleeSettingChange} placeholder="Default" />
                    </label>
                    <label>Override pMaxFinal:
                        <input type="number" name="overridePMaxFinal" min="0" max="0.99" step="0.001" value={flee.overridePMaxFinal ?? ''} onChange={this.handleFleeSettingChange} placeholder="Default" />
                    </label>
                    <button type="button" className="button-secondary" onClick={this.resetFleeSettings}>Reset Flee Settings</button>
                </fieldset>
                {/* <label>XpRequired:
                    <input type="number" name="xpReqired" value={regions.xpReqired} onChange={this.handleInputChange} />
                </label> */}
                <label>CanBeStartRegion:
                    <input type="checkbox" name="canBeStartRegion" checked={regions.canBeStartRegion} onChange={this.handleInputChange} />
                </label>




                {creatingNewRegions ?
                    <div>
                        {/* Form to create a new regions, similar to the update form... */}
                        <button className="button-primary" disabled={Boolean(routeCostValidation || enemyLevelValidation)} onClick={() => onCreate(regions)}>Create</button>
                        <button className="button-secondary" onClick={() => onCancelCreate()}>Cancel</button>
                    </div>
                    :
                    <div>
                        <button className="button-primary" disabled={Boolean(routeCostValidation || enemyLevelValidation)} onClick={() => onUpdate(regions)}>Update</button>
                        <button className="button-critical" onClick={() => onDelete(regions)}>Delete</button>

                    </div>

                }


            </div>
        );


    }

}
